import { computed, inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import Keycloak, { KeycloakTokenParsed } from 'keycloak-js';
import { KEYCLOAK_EVENT_SIGNAL } from 'keycloak-angular';
import { AuthService, AuthUser } from './auth.service';

function toAuthUser(idToken: KeycloakTokenParsed | undefined): AuthUser | null {
  if (!idToken?.sub) {
    return null;
  }
  return {
    id: idToken.sub,
    name: idToken['name'] ?? idToken['preferred_username'] ?? idToken.sub,
    email: idToken['email'] ?? null,
    tenant: idToken['tenant'] ?? null,
  };
}

@Injectable()
export class KeycloakAuthService extends AuthService {
  private readonly keycloak = inject(Keycloak);
  private readonly keycloakEvent = inject(KEYCLOAK_EVENT_SIGNAL);
  private readonly origin = inject(DOCUMENT).location.origin;

  readonly isAuthenticated = computed(() => {
    this.keycloakEvent();
    return this.keycloak.authenticated;
  });

  readonly user = computed(() => {
    this.keycloakEvent();
    return toAuthUser(this.keycloak.idTokenParsed);
  });

  logout(): Promise<void> {
    return this.keycloak.logout({ redirectUri: this.origin + '/' });
  }
}
